import React from 'react';
import PropTypes from 'prop-types';
import styles from './FormColumn.module.css';

const FormColumn = ({ children, cols = 6, fullWidth, equal5 }) => {
  const validCols = cols >= 1 && cols <= 12 ? cols : 6;
  
  let columnClass = styles[`cols-${validCols}`];
  
  if (equal5) {
    columnClass = styles['cols-5-equal'];
  } else if (fullWidth) {
    columnClass = styles.fullWidth;
  }

  return (
    <div className={`${styles.formCol} ${columnClass}`}>
      {children}
    </div>
  );
};

FormColumn.propTypes = {
  children: PropTypes.node,
  cols: PropTypes.number,
  fullWidth: PropTypes.bool,
  equal5: PropTypes.bool
};

FormColumn.defaultProps = {
  cols: 6,
  fullWidth: false,
  equal5: false
};

export default FormColumn;